import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppService } from '../app.service';
export interface CheckerData {
  employeeId: string;
  firstName: string;
  lastName: string;
  designation: string;
  grade: string;
  dateOfJoining: string;
  email: string;
  plant: string;
  department: string;
  requester: string;
}
@Component({
  selector: 'app-hrclosure',
  templateUrl: './hrclosure.component.html',
  styleUrls: ['./hrclosure.component.scss']
})
export class HrclosureComponent implements OnInit {
hrclosure!: FormGroup;
checkerData: any = {};
public hrclosuredata:any={};
  constructor(private toastr: ToastrService,public appservice:AppService) { 


  }
   onHrSubmit() {
  // Your logic here
  this.checkerData.createdby=this.appservice.username;
  this.appservice.hrclosuredata=[];
  this.checkerData.type=this.appservice.Hrcloser_type;
  this.appservice.postTable("api/Transaction/updateHRCloser",this.checkerData).subscribe((res:any)=>{
      this.hrclosuredata=JSON.parse(res);
    this.appservice.gethrclosuredata();
  });
      this.appservice.gethrclosuredata();
      this.appservice.goback();
  //console.log("HR Closure form submitted!");
  this.toastr.success("HR Closure submitted successfully!");
}
onload(data){
  this.appservice.getTable("api/Transaction/Getempdetailsforhrcl?empid="+data).subscribe((res:any)=>{
      this.hrclosuredata=this.appservice.getJsondata(res);
      if(this.hrclosuredata&&this.hrclosuredata.length>0){
        let emp=this.hrclosuredata[0];
        this.checkerData.OD_iid=emp.OD_iid;
        this.checkerData.employeeId=emp.OD_EmployeeID;
        this.checkerData.fullname=emp.OD_Full_Name;
        //alert("the empname is " + emp.OD_Full_Name);
        
        this.checkerData.designation=emp.OD_Designation;
        this.checkerData.grade=emp.OD_Grad;
        this.checkerData.dateOfJoining=emp.OD_Dateofjoin;
        this.checkerData.email=emp.OD_Email;
        this.checkerData.plant=emp.OD_Plant;
        this.checkerData.department=emp.OD_Department;
        this.checkerData.requester=emp.OD_OnboardingCreatedby;
        this.checkerData.checker=emp.OD_CheckerCreatedby;
        this.checkerData.final=emp.OD_FinalApprovedby; 
        this.checkerData.username=emp.OD_ITAD_AccountName;
        this.checkerData.Mailid=emp.OD_CMailid;
        this.checkerData.OD_Account_type = emp.OD_Account_type;
        this.checkerData.Furtherdepartment = emp.OD_Changing_Department
        

      }
     // this.checkerData.employeeId=
      console.log("the values",this.checkerData);
        });
}
  ngOnInit(): void {
    this.onload(this.appservice.hrclosureeditid);

  }

}
